import type { DataTableNumberOperator } from '@/components/molecules';
import type { ReceiptKind, ReceiptDeliveryStatusFilter } from '@/hooks/receipts';

export type ReceiptKindFilter = ReceiptKind | 'all';
export type ReceiptDeliveryFilter = 'all' | ReceiptDeliveryStatusFilter;

export interface ReceiptListFilters {
  q: string;
  kind: ReceiptKindFilter;
  delivery: ReceiptDeliveryFilter;
  receiptNumber: string;
  invoiceNumber: string;
  method: string;
  totalOp: DataTableNumberOperator;
  totalValue: string;
  sort: number;
  page: number;
  dateFrom: string | undefined;
  dateTo: string | undefined;
}

export const DEFAULT_RECEIPT_LIST_FILTERS: ReceiptListFilters = {
  q: '',
  kind: 'all',
  delivery: 'all',
  receiptNumber: '',
  invoiceNumber: '',
  method: '',
  totalOp: 'eq',
  totalValue: '',
  sort: 0,
  page: 1,
  dateFrom: undefined,
  dateTo: undefined,
};

export const RECEIPT_KIND_FILTERS: { value: ReceiptKindFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'PAYMENT', label: 'Payment' },
  { value: 'DEPOSIT', label: 'Deposit' },
];

/** "Failed delivery" excludes Not sent on purpose: it is about real delivery problems. */
export const RECEIPT_DELIVERY_FILTERS: { value: ReceiptDeliveryFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'FAILED', label: 'Failed delivery' },
  // QUEUED covers both badges a queued row can show: Sending… and Retrying.
  { value: 'QUEUED', label: 'Sending / retrying' },
  { value: 'SENT', label: 'Sent' },
  { value: 'NOT_SENT', label: 'Not sent' },
];

export function parseReceiptDeliveryFilter(value: unknown): ReceiptDeliveryFilter {
  return RECEIPT_DELIVERY_FILTERS.some((filter) => filter.value === value)
    ? (value as ReceiptDeliveryFilter)
    : 'all';
}

export function toDeliveryStatusParam(
  filter: ReceiptDeliveryFilter,
): ReceiptDeliveryStatusFilter | undefined {
  return filter === 'all' ? undefined : filter;
}
